/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFloorplans200ResponseInnerTablesInner } from './GetFloorplans200ResponseInnerTablesInner';
import {
    GetFloorplans200ResponseInnerTablesInnerFromJSON,
    GetFloorplans200ResponseInnerTablesInnerFromJSONTyped,
    GetFloorplans200ResponseInnerTablesInnerToJSON,
    GetFloorplans200ResponseInnerTablesInnerToJSONTyped,
} from './GetFloorplans200ResponseInnerTablesInner';

/**
 * 
 * @export
 * @interface GetFloorplans200ResponseInner
 */
export interface GetFloorplans200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInner
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInner
     */
    controlPrinter: string | null;
    /**
     * 
     * @type {Array<GetFloorplans200ResponseInnerTablesInner>}
     * @memberof GetFloorplans200ResponseInner
     */
    tables: Array<GetFloorplans200ResponseInnerTablesInner>;
}

/**
 * Check if a given object implements the GetFloorplans200ResponseInner interface.
 */
export function instanceOfGetFloorplans200ResponseInner(value: object): value is GetFloorplans200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('controlPrinter' in value) || value['controlPrinter'] === undefined) return false;
    if (!('tables' in value) || value['tables'] === undefined) return false;
    return true;
}

export function GetFloorplans200ResponseInnerFromJSON(json: any): GetFloorplans200ResponseInner {
    return GetFloorplans200ResponseInnerFromJSONTyped(json, false);
}

export function GetFloorplans200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFloorplans200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': json['position'],
        'controlPrinter': json['controlPrinter'],
        'tables': ((json['tables'] as Array<any>).map(GetFloorplans200ResponseInnerTablesInnerFromJSON)),
    };
}

export function GetFloorplans200ResponseInnerToJSON(json: any): GetFloorplans200ResponseInner {
    return GetFloorplans200ResponseInnerToJSONTyped(json, false);
}

export function GetFloorplans200ResponseInnerToJSONTyped(value?: GetFloorplans200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'position': value['position'],
        'controlPrinter': value['controlPrinter'],
        'tables': ((value['tables'] as Array<any>).map(GetFloorplans200ResponseInnerTablesInnerToJSON)),
    };
}

